export default {
  state: {
    stats: {},
    filterOptions: {},
    filters: {},
  },
  mutations: {
    setStats(state, payload) {
      state.stats = payload
    },
    setStatsFilters(state, payload) {
      state.filters = payload
    },
    setfilterOptions(state, payload) {
      state.filterOptions = payload
    },
    clearStats(state) {
      state.stats = {}
    }
  },
  actions: {
    queryStats({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      commit('clearStats')
      let queryFilters = {...state.filters}
      if (queryFilters.partner && queryFilters.partner.length > 0) queryFilters.partner = queryFilters.partner.join(',')

      console.log('queryFilters', queryFilters)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'stats', {params: queryFilters})
        .then(res => {
          commit('setStats', res.data.stats)
          commit('setfilterOptions', res.data.filterOptions)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getStats: state => {
      return state.stats
    },
    getFilterOptions: state => {
      return state.filterOptions
    },
    getFilters: state => {
      return state.filters
    },
  }
}